import React from 'react';
import { TargetIcon, FlameIcon, ZapIcon, TrendingUpIcon, BrainIcon, UsersIcon } from 'lucide-react';
import { benefits } from '../data/benefits';
import type { BenefitIcon } from '../types/offer';
const ICONS: Record<BenefitIcon, typeof TargetIcon> = {
  target: TargetIcon,
  muscle: FlameIcon,
  pressure: ZapIcon,
  wealth: TrendingUpIcon,
  brain: BrainIcon,
  community: UsersIcon
};
export function Benefits() {
  return <section id="benefits" aria-labelledby="benefits-heading" className="border-y border-white/10 bg-navy-900" data-id="element-11" data-mp="3qsf8ju8q141c">
      <div className="mx-auto grid max-w-content gap-12 px-4 py-20 sm:px-6 lg:grid-cols-[0.85fr_1.15fr] lg:gap-20 lg:py-28" style={{
      paddingTop: "25px",
      paddingBottom: "25px"
    }} data-id="element-12" data-mp="3mohdbumioddk">
        <div className="lg:sticky lg:top-28 lg:self-start" data-id="element-13" data-mp="3ctfnewkf379x">
          <p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-celeste-400" data-id="element-14" data-mp="1g04bpl9laf32">
            রূপান্তর
          </p>
          <h2 id="benefits-heading" className="mt-4 font-display text-3xl font-extrabold leading-tight tracking-tight text-white sm:text-[2.75rem]" data-id="element-15" data-mp="1b1169zpp66uk">
            দ্য আর্জেন্টাইন মাইন্ডসেট আয়ত্ত করলে কী কী বদলায়
          </h2>
          <p className="mt-4 text-white/70" data-id="element-16" data-mp="6qowkwkwaanl">
            ছয়টি পরিবর্তন। ধীরে পড়ুন — আজকের জীবন আর যে জীবনের জন্য আপনি খাটছেন, পার্থক্যটা
            ঠিক এখানেই।
          </p>
        </div>

        <ul className="divide-y divide-white/10 border-y border-white/10" data-id="element-17" data-mp="3tzlheh3t43df">
          {benefits.map((benefit, index) => {
          const Icon = ICONS[benefit.icon];
          const isFirst = index === 0;
          return <li key={benefit.title} className="flex gap-5 py-7" style={{
            paddingTop: "7px",
            paddingBottom: "7px"
          }} data-id="element-18" data-mp="qilgq1c8iuzp" data-mpi={index}>
                <span className={`mt-0.5 flex shrink-0 items-center justify-center rounded-lg border border-celeste-500/30 bg-navy-800 ${isFirst ? 'h-12 w-12' : 'h-10 w-10'}`} aria-hidden="true" data-id="element-19" data-mp="gpxn1fgjx757">
                  <Icon className={`text-celeste-400 ${isFirst ? 'h-6 w-6' : 'h-5 w-5'}`} data-id="element-20" data-mp="198bix9ibuj1n" />
                </span>
                <div data-id="element-21" data-mp="1j2qkb81b8puo">
                  <h3 className={`font-display font-extrabold tracking-tight text-white ${isFirst ? 'text-xl sm:text-2xl' : 'text-lg'}`} data-id="element-22" data-mp="1j160accmgpb2">
                    {benefit.title}
                  </h3>
                  <p className={`mt-2 leading-relaxed text-white/70 ${isFirst ? 'text-base sm:text-lg' : 'text-[15px]'}`} data-id="element-23" data-mp="1975ppuykmruy">
                    {benefit.description}
                  </p>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}